const baseURL = '/coupons';

async function check(code) {
    const res = await axios.get(`${baseURL}/check`, {
        params: {
            code,
        },
    });
    return res.data;
}

async function consume(code) {
    const res = await axios.post(`${baseURL}/consume`, {
        code,
    });
    return res.data;
}

async function fetchUsedCoupons() {
    const res = await axios.get(`${baseURL}/usedCoupons`);
    return res.data;
}

export default {
    check,
    consume,
    fetchUsedCoupons,
};
